import type { Distance, Point } from "@pdfking/math"
import { Hypot, Scale, Subtract, Total } from "@pdfking/math"

import type { FolderSide } from "#internal"

import { FolderAt } from "./FolderAt"
import { FolderChain } from "./FolderChain"
import { FolderStraight } from "./FolderStraight"

/** `side` on the middle `width` of an edge; the edge as it is when it is no
 * longer than that. */
export const FolderCentered =
  (width: Distance, side: FolderSide): FolderSide =>
  (a, b) => {
    const length = Hypot(Subtract(b.x, a.x), Subtract(b.y, a.y)) as Distance
    if (length <= width) return FolderStraight(a, b)
    const at = (along: Distance): Point<Distance> => ({
      x: Total(a.x, Scale(Subtract(b.x, a.x), along / length)),
      y: Total(a.y, Scale(Subtract(b.y, a.y), along / length)),
    })
    return FolderChain(
      FolderAt(a.x, a.y),
      side(at(Scale(Subtract(length, width), 0.5)), at(Scale(Total(length, width), 0.5))),
      FolderAt(b.x, b.y)
    )
  }
